import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import TestimonialCard from '../../components/card/test-card';
import emekaimg from "../../image/client/emeka.jpg";
import johnimg from "../../image/client/john.jpg";
import lyndaimg from "../../image/client/lynda.jpg";
import philomenaimg from "../../image/client/philomena.jpg";
import rakibianimg from "../../image/client/rakibian.jpg";
import thompsonimg from "../../image/client/thompson.jpg";
import turanimg from "../../image/client/turan.jpg";

const Testimonials = () => {
    return (
        <div className='h-auto mt-4 bg-white/30 rounded-lg py-2'>
                        <div className="text-3xl font-extrabold font-mono text-white text-center w-auto "> <span className='text-yellow-300'>MY</span> CLIENTS' TESTIMONIALS</div>
            <div className="w-full flex  justify-center items-center md:pl-12 ">
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    pagination={{ clickable: true }}
                    spaceBetween={10}
                    slidesPerView={1}

                    direction='horizontal'
                    loop={true}
                    autoplay={{ delay: 10000 }}
                    breakpoints={{

                        1024: {
                            slidesPerView: 3
                        }

                    }}
                    className='h-full'
                >
                    <SwiperSlide className=''> <TestimonialCard text="Collaborating with Otsu Udoka was a game-changer for my business! His attention to detail and creative approach brought my vision to life. The e-store web app he built exceeded my expectations."
                        image={emekaimg} imagename="emekapic" clientName="EMEKA WILLIAMS" title="CEO Moobo Fashions"
                    /> </SwiperSlide>
                    <SwiperSlide> <TestimonialCard 
                    text="Thrilled with the blog web app Otsu Udoka created! Seamless blend of functionality and sleek design, providing an outstanding user experience. Responsive, talented, and a pleasure to work with!"
                        image={lyndaimg} imagename="lyndapic" clientName="LYNDA SMITH" title="CEO Buzzstone"
                    /> </SwiperSlide>
                    <SwiperSlide> <TestimonialCard text="Best decision ever choosing Otsu Udoka for my web development needs. Their expertise, professionalism, and commitment to deadlines were remarkable. My new site has significantly boosted my online presence."
                        image={philomenaimg} imagename="philomenapic" clientName="PHILOMENA ABDULAHI" title="CEO & Founder Phlox Electronics"
                    /> </SwiperSlide>
                    <SwiperSlide> <TestimonialCard text="Highly recommend Otsu Udoka for top-notch web development. From concept to completion, they demonstrated exceptional skill and dedication. The end result? A website that perfectly represents my School."
                        image={rakibianimg} imagename="rakibianpic" clientName="RAKIBIAN ASLAM" title="Administrator Eduma Schools"
                    /> </SwiperSlide>
                    <SwiperSlide> <TestimonialCard text="Working with Otsu Udoka was a breeze. He quickly grasped my requirements and added his creative flair to make my website stand out. Excellent communication, and the final product exceeded my expectations."
                        image={turanimg} imagename="turanpic" clientName="TURAN FRED" title="CEO & Founder Turan Outfits"
                    /> </SwiperSlide>
                    <SwiperSlide> <TestimonialCard text="Thrilled with the website Otsu Udoka developed for my business. His technical expertise and keen eye for design resulted in a site that's visually stunning and functional. Clients love the new look!"
                        image={johnimg} imagename="johnpic" clientName="JOHN OLUADE" title="CEO & Founder Smart Hotels and Suites"
                    /> </SwiperSlide>
                    <SwiperSlide> <TestimonialCard text="Huge thank you to Otsu Udoka for transforming my ideas into a fantastic website. His ability to translate my vision into reality was impressive, and the support they provided throughout the process was invaluable. Couldn't be more pleased!"
                        image={thompsonimg} imagename="thompic" clientName="THOMPSON MMADU" title="CEO & Founder Top Estate LTD"
                    /> </SwiperSlide>

                </Swiper>
            </div>
        </div>
    );
}

export default Testimonials;